import { useSearchParams } from "react-router-dom";
import { useState, useEffect } from "react";
import axios from "axios";
import API_BASE_URL from "../config/api";

function UnsubscribePage() {
  const [searchParams] = useSearchParams();
  const email = searchParams.get("email");
  const [status, setStatus] = useState("loading");

  useEffect(() => {
    if (!email) {
      setStatus("no-email");
      return;
    }
    axios.post(`${API_BASE_URL}/api/v1/unsubscribe`, { email })
      .then(() => setStatus("success"))
      .catch(() => setStatus("error"));
  }, [email]);

  return (
    <div style={{ maxWidth: 480, margin: "80px auto", textAlign: "center", padding: "0 20px" }}>
      {status === "loading" && <p>Processing your request...</p>}
      {status === "no-email" && (
        <>
          <h2>Unsubscribe</h2>
          <p>No email address provided. Click the link from your email to unsubscribe.</p>
        </>
      )}
      {status === "success" && (
        <>
          <h2>Successfully Unsubscribed</h2>
          <p>{email} has been removed from our mailing list. You will no longer receive newsletters.</p>
        </>
      )}
      {status === "error" && (
        <>
          <h2>Something went wrong</h2>
          <p>We couldn't process your request. Please try again or contact support.</p>
        </>
      )}
    </div>
  );
}

export default UnsubscribePage;
